<template>
    <div>
        <menu-preview />
    </div>
</template>

<script>
import Home from "@/views/menu/Home.vue";
import { mapState } from 'vuex'

export default {
    data(){ 
        return {
                eventName:"visibilitychange" 
            }
    },
    components : {
        "menu-preview":Home
    },
    computed: {
		...mapState({
			menus: 'menus'
        }),
    },
    methods:{
        visibilityChanged() {
            if (document.hidden || document.mozHidden || document.msHidden || document.webkitHidden) {
                console.log("Preview Hidden")
            } else {
                console.log("Preview Shown")
                this.$store.dispatch('renderMenu');
            }           
        }
    },
    created(){ 
        if (document.webkitHidden != undefined) {
            this.eventName = "webkitvisibilitychange";
        } else if (document.mozHidden != undefined) {
            this.eventName = "mozvisibilitychange";
        } else if (document.msHidden != undefined) {
            this.eventName = "msvisibilitychange";
        } 
        window.addEventListener(this.eventName, this.visibilityChanged, false)
    },
    destroyed() {
        window.removeEventListener(this.eventName, this.visibilityChanged)        
    },
}
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
	@import '~pretty-checkbox/src/pretty-checkbox.scss';
	@import "@/scss/_main";
</style>